
<template>
  <el-collapse
    v-if="status >= 8"
    :value="status <= 10 ? '1' : ''"
  >
    <el-collapse-item name="1">
      <template slot="title">
        &nbsp;
        <span>{{$t('Təmir_mərkəzi')}}</span>
      </template>
      <card>
        <div class="row">
          <div class="col-9"></div>
          <div class="col-3">
            <div
              style="text-align: center"
              :class="status ? statusColor(status) : ''"
            >
              <span style="font-size: 11pt; color: white; text-align: center">
                {{ item.techExpertStatusName }}
              </span>
            </div>
          </div>
        </div>
        <el-form v-loading="loading" v-if="status >= 4">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-4">
                <el-form-item :label="$t('İlkin_məbləğ')" prop="startServiceSum">
                  <el-input type="number"
                    :readonly="status >= 9 || readonly"
                    v-model="item.startServiceSum"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="startServiceNote">
                  <el-input
                    :readonly="status >= 9 || readonly"
                    v-model="item.startServiceNote"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 47px">
                <el-form-item>
                  <el-button size="small"
                    id="button"
                    type="primary"
                    v-if="status < 9 && !readonly"
                    @click="onStart"
                    >{{$t('Təmir_başladı')}}</el-button
                  >

                  <div v-if="item.startServiceDate">
                    <created-label
                      :created="item.startServiceCreatedBy"
                      :type="1"
                    />
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <el-form v-loading="loading" v-if="status >= 9">
          <div>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-md-2">
                <el-form-item :label="$t('Yekun_məbləğ')" prop="finalServiceSum">
                  <el-input type="number"
                    :readonly="status >= 10 || readonly"
                    id="finalServiceSum"
                    v-model="item.finalServiceSum"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="col-md-2">
                <el-form-item :label="$t('Yekun_akt_tarixi')" prop="finalActDate">
                  <el-date-picker
                    :readonly="status >= 10 || readonly"
                    type="date"
                    v-model="item.finalActDate"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </div>
              <div class="col-md-4">
                <el-form-item :label="$t('Qeyd')" prop="finalServiceNote">
                  <el-input
                    :readonly="status >= 10 || readonly"
                    v-model="item.finalServiceNote"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="col-md-4" style="margin-top: 47px">
                <el-form-item>
                  <el-button size="small"
                    id="button"
                    type="primary"
                    v-if="status < 10 && !readonly"
                    @click="onFinish"
                    >{{$t('Təmir_yekunlaşdı')}}</el-button
                  >

                  <div v-if="item.finalServiceDate">
                    <created-label
                      :created="item.finalServiceCreatedBy"
                      :type="1"
                    />
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>

        <div class="row">
          <div class="col-12">
            <dir class="col-12">
              <upload
                :disabled="status > 9 || readonly"
                ref="upload"
                :sourcetype="6"
                :sourceId="item.claimId"
                :autoupload="true"
                :downloadAll="false"
                listtype="text"
              ></upload>
            </dir>
          </div>
        </div>
      </card>
    </el-collapse-item>
  </el-collapse>
</template>


<script>
import CreatedLabel from "./CreatedLabel.vue";
import Upload from "./Upload.vue";
import { UpdateTechExpert } from "../../services/claim";

export default {
  components: {
    Upload,
    CreatedLabel,
  },
  props: {
    value: Object,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      item: this.value,
      status: this.value.status,
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    statusColor(status) {
      switch (status) {
        case 9:
          return "p-2 mb-2 bg-info text-dark rounded";
        case 10:
          return "p-2 mb-2 bg-success text-dark rounded";
        default:
          return "text-default";
      }
    },
    onStart() {
      this.$confirm(this.$t('Təmir_başlanır'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "info",
      })
        .then(() => {
          this.loading = true;
        })
        .then(() => {
          this.save(7);
        });
    },
    onFinish() {
      this.$confirm(this.$t('Təmir_yekunlaşıb'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
        type: "info",
      }).then(() => {
        this.save(8);
      });
    },
    save(stage) {
      this.item.stage = stage;
      this.item.commandUserId = this.uid
      UpdateTechExpert(this.item).then((response) => {
        this.loading = false;
        if (response.data.data) {
          if (!response.data.isSuccess) {
            this.$message({
              type: "error",
              message: response.data.errors[0],
            });
          } else {
            this.$message({
              type: "success",
              message: this.$t('Uğurlu_əməliyyat'),
            });
            this.$emit("refresh");
          }
        } else {
          this.$message({
            type: "error",
            message: this.$t('Səhv_əməliyyat'),
          });
        }
      });
    },
    // getActiveServiceCenters() {
    //   GetActiveServiceCenters().then((response) => {
    //     if (response.data.data) {
    //       this.serviceCenters = response.data.data;
    //     } else {
    //       this.$message({
    //         type: "error",
    //         message: "Service Centers: No data found!",
    //       });
    //     }
    //   });
    // },
  },
  mounted() {
    // this.getActiveServiceCenters();
  },
  watch: {
    value() {
      this.status = this.value.status;
      this.item = this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.record-label {
  font-size: var(--font-primary);
  font-style: italic;
}
</style>